import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import axios from "axios";


function PrivateRouter({ component: Component, ...rest }) {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  if(typeof userInfo !== 'undefined' && userInfo !== null){
    const token = userInfo.token;
    if(typeof token != undefined && token){
      axios.defaults.headers.common['Authorization'] = `Bearer ${userInfo.token}`;//send token
    }
  }

  let isAdmin = 2;
  const role = userInfo?.data?.role;
  if (userInfo){
    isAdmin = (userInfo.data.isAdmin === true) ? 1 : 0;
  }

  // Role-aware landing so a direct URL hit doesn't leave the user on a
  // page that doesn't match their role's sidebar. Super_Admin owns the
  // `/organizations*` surface; every other role owns `/apps*`.
  // Keeping this in one place avoids each page re-deriving it.
  const homeForRole = role === 'Super_Admin' ? '/organizations' : '/apps';

  return (
    <Route
      {...rest}
      component={(props) => {
        if (!(isAdmin === 1 || isAdmin === 0)) {
          return <Redirect to={`/landing`} />;
        }

        const path = props.location.pathname;

        if (path === '/') {
          return <Redirect to={homeForRole} />;
        }

        // Super_Admin hitting the tenant `/apps*` surface → bounce to
        // their real landing. (They have no apps of their own.)
        if (role === 'Super_Admin' && /^\/(apps|app(\/|$))/.test(path)) {
          return <Redirect to="/organizations" />;
        }

        // Non-Super_Admin hitting the `/organizations` index → bounce
        // back to their apps. They still need `/organization/details/:id`
        // and `/organization/create` — those stay allowed.
        if (role !== 'Super_Admin' && path === '/organizations') {
          return <Redirect to="/apps" />;
        }

        return <Component {...props} />;
      }}
    />
  );
}

export default PrivateRouter;
